import React from 'react';
import './DocumentsTable.css';

const DocumentsTable = () => {
  return (
    <div className="documents-wrapper">
      <div className="documents-header">
        <h3>All documents</h3>
        <div className="search-box">
          <span className="search-icon">🔍</span>
          <input type="text" placeholder="Search by name" />
        </div>
      </div>

      <div className="documents-table">
        <div className="documents-row">
          <div className="column title">This is a test attachment for dev</div>
          <div className="column modified">07-15-2025</div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsTable;
